/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class SearchResources200ResponseTablesInnerSource {
  'name'?: string;
  'dbEngine'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "dbEngine",
      "baseName": "dbEngine",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SearchResources200ResponseTablesInnerSource.attributeTypeMap;
  }

  public constructor() {
  }
}

